export default __webpack_public_path__ + "static/media/1insta.242381aa.jpg";